export default "__VITE_ASSET__c56877f3__"